// Field schemas that drive the generic admin CRUD UI.

const SEO = [
  { name: "seo_title", label: "SEO Başlığı", type: "text", full: true },
  { name: "seo_description", label: "SEO Açıklaması", type: "textarea", full: true },
];

export const COLLECTIONS = {
  services: {
    label: "Hizmetler",
    endpoint: "services",
    titleField: "name",
    fields: [
      { name: "name", label: "Hizmet Adı", type: "text" },
      { name: "slug", label: "Slug (url)", type: "text" },
      { name: "h1", label: "H1 Başlık", type: "text" },
      { name: "category_slug", label: "Kategori Slug", type: "text" },
      { name: "hero_image", label: "Hero Görseli (sayfa üstü)", type: "image", preset: "hero", full: true },
      { name: "card_image", label: "Kart Görseli (listelerde — boşsa Hero)", type: "image", preset: "card", full: true },
      { name: "og_image", label: "Open Graph Görseli (paylaşım — boşsa Hero)", type: "image", preset: "og", full: true },
      { name: "excerpt", label: "Kısa Özet", type: "textarea", full: true },
      { name: "intro", label: "Giriş Metni", type: "longtext", full: true },
      { name: "what_is", label: "Nedir?", type: "longtext", full: true },
      { name: "who_for", label: "Kimler İçin?", type: "longtext", full: true },
      { name: "when_to", label: "Ne Zaman?", type: "longtext", full: true },
      { name: "duration", label: "Uygulama Süresi", type: "text" },
      { name: "order", label: "Sıra", type: "number" },
      { name: "benefits", label: "Faydaları (her satır bir madde)", type: "stringlist", full: true },
      { name: "cautions", label: "Dikkat Edilmesi Gerekenler", type: "stringlist", full: true },
      { name: "gallery", label: "Galeri Görselleri", type: "imagelist", preset: "gallery", full: true },
      { name: "related", label: "İlgili Hizmet Slug'ları", type: "stringlist", full: true },
      { name: "related_blogs", label: "Öne Çıkan Blog Slug'ları (boş ise otomatik eşleşir)", type: "stringlist", full: true },
      { name: "related_cases", label: "Öne Çıkan Uygulama Slug'ları (boş ise otomatik)", type: "stringlist", full: true },
      { name: "related_districts", label: "Öne Çıkan İlçe Sayfa Slug'ları (boş ise otomatik)", type: "stringlist", full: true },
      { name: "process", label: "Uygulama Adımları", type: "steplist", full: true },
      { name: "faqs", label: "Sık Sorulan Sorular", type: "faqlist", full: true },
      { name: "published", label: "Yayında", type: "switch" },
    ],
  },
  categories: {
    label: "Hizmet Kategorileri",
    endpoint: "categories",
    titleField: "name",
    fields: [
      { name: "name", label: "Kategori Adı", type: "text" },
      { name: "slug", label: "Slug", type: "text" },
      { name: "icon", label: "İkon (Sparkles, ShieldCheck, Armchair, PanelTop, Cog, CircleDot, Lightbulb, Droplets)", type: "text", full: true },
      { name: "image", label: "Görsel", type: "image", preset: "category", full: true },
      { name: "short", label: "Kısa Açıklama", type: "textarea", full: true },
      { name: "order", label: "Sıra", type: "number" },
      { name: "sub_services", label: "Alt Hizmetler (her satır bir hizmet)", type: "stringlist", full: true },
    ],
  },
  lokasyonlar: {
    label: "İlçe SEO Sayfaları",
    endpoint: "lokasyonlar",
    titleField: "h1",
    fields: [
      { name: "h1", label: "H1 Başlık", type: "text" },
      { name: "slug", label: "Slug (örn. seramik-kaplama-izmit)", type: "text" },
      { name: "service_name", label: "Hizmet Adı", type: "text" },
      { name: "service_slug", label: "Hizmet Slug", type: "text" },
      { name: "district", label: "İlçe Adı", type: "text" },
      { name: "district_slug", label: "İlçe Slug", type: "text" },
      { name: "ref_service", label: "Bağlı Hizmet Sayfası Slug", type: "text", full: true },
      ...SEO,
      { name: "hero_image", label: "Kapak Görseli", type: "image", preset: "hero", full: true },
      { name: "intro", label: "Giriş Metni", type: "longtext", full: true },
      { name: "why_us", label: "Neden Biz?", type: "longtext", full: true },
      { name: "published", label: "Yayında", type: "switch" },
    ],
  },
  blogs: {
    label: "Blog Yazıları",
    endpoint: "blogs",
    titleField: "title",
    fields: [
      { name: "title", label: "Başlık", type: "text" },
      { name: "slug", label: "Slug", type: "text" },
      { name: "category_slug", label: "Kategori Slug", type: "text" },
      { name: "cover_image", label: "Kapak Görseli", type: "image", preset: "blog", full: true },
      ...SEO,
      { name: "excerpt", label: "Özet", type: "textarea", full: true },
      { name: "content", label: "İçerik (paragraflar satır ile ayrılır)", type: "longtext", full: true },
      { name: "tags", label: "Etiketler", type: "stringlist", full: true },
      { name: "published", label: "Yayında", type: "switch" },
    ],
  },
  "blog-categories": {
    label: "Blog Kategorileri",
    endpoint: "blog-categories",
    titleField: "name",
    fields: [
      { name: "name", label: "Kategori Adı", type: "text" },
      { name: "slug", label: "Slug", type: "text" },
    ],
  },
  "case-studies": {
    label: "Uygulamalar",
    endpoint: "case-studies",
    titleField: "title",
    fields: [
      { name: "title", label: "Başlık", type: "text" },
      { name: "slug", label: "Slug", type: "text" },
      { name: "brand", label: "Marka *", type: "text" },
      { name: "model", label: "Model *", type: "text" },
      { name: "year", label: "Yıl *", type: "number" },
      { name: "district", label: "İlçe *", type: "text" },
      { name: "district_slug", label: "İlçe Slug * (örn. izmit)", type: "text" },
      { name: "duration", label: "Süre * (örn. 1 Gün)", type: "text" },
      { name: "method", label: "Yöntem", type: "text" },
      { name: "featured", label: "Öne Çıkan mı?", type: "switch" },
      { name: "before_image", label: "Öncesi Fotoğrafı *", type: "image", preset: "portrait", full: true },
      { name: "after_image", label: "Sonrası Fotoğrafı *", type: "image", preset: "portrait", full: true },
      { name: "cover_image", label: "Kapak Görseli (premium araç)", type: "image", preset: "card", full: true },
      { name: "summary", label: "Kısa Açıklama / Özet *", type: "textarea", full: true },
      { name: "result", label: "Sonuç (çıktı cümlesi)", type: "textarea", full: true },
      { name: "content", label: "Detaylı İçerik", type: "longtext", full: true },
      { name: "services", label: "Uygulanan Hizmetler", type: "stringlist", full: true },
      { name: "gallery", label: "Galeri", type: "imagelist", preset: "vertical", full: true },
      { name: "related_services", label: "İlgili Hizmet Slug'ları (iç-link için)", type: "stringlist", full: true },
      { name: "published", label: "Yayında", type: "switch" },
    ],
  },
  "district-hubs": {
    label: "İlçe Hub Sayfaları",
    endpoint: "district-hubs",
    titleField: "h1",
    fields: [
      { name: "h1", label: "H1 Başlık", type: "text" },
      { name: "slug", label: "Slug (örn. izmit)", type: "text" },
      { name: "district", label: "İlçe Adı", type: "text" },
      { name: "district_slug", label: "İlçe Slug", type: "text" },
      ...SEO,
      { name: "hero_image", label: "Kapak Görseli", type: "image", preset: "hero", full: true },
      { name: "intro", label: "Giriş Metni", type: "longtext", full: true },
      { name: "why_us", label: "Neden Biz?", type: "longtext", full: true },
      { name: "nearby", label: "Yakın İlçe Slug'ları", type: "stringlist", full: true },
      { name: "published", label: "Yayında", type: "switch" },
    ],
  },
  "before-after": {
    label: "Öncesi / Sonrası",
    endpoint: "before-after",
    titleField: "title",
    fields: [
      { name: "title", label: "Başlık", type: "text" },
      { name: "service", label: "Hizmet", type: "text" },
      { name: "before_image", label: "Öncesi Görseli", type: "image", preset: "ba", full: true },
      { name: "after_image", label: "Sonrası Görseli", type: "image", preset: "ba", full: true },
      { name: "order", label: "Sıra", type: "number" },
    ],
  },
  faqs: {
    label: "Sık Sorulan Sorular",
    endpoint: "faqs",
    titleField: "question",
    fields: [
      { name: "question", label: "Soru", type: "text", full: true },
      { name: "answer", label: "Cevap", type: "textarea", full: true },
    ],
  },
  reviews: {
    label: "Müşteri Yorumları",
    endpoint: "reviews",
    titleField: "name",
    fields: [
      { name: "name", label: "İsim", type: "text" },
      { name: "car", label: "Araç (Marka / Model)", type: "text" },
      { name: "service", label: "Hizmet", type: "text" },
      { name: "rating", label: "Puan (1-5)", type: "number" },
      { name: "date", label: "Tarih (örn. 2025-03)", type: "text" },
      { name: "source", label: "Kaynak (Google vb.)", type: "text" },
      { name: "order", label: "Sıra", type: "number" },
      { name: "text", label: "Yorum", type: "textarea", full: true },
    ],
  },
  campaigns: {
    label: "Kampanyalar",
    endpoint: "campaigns",
    titleField: "title",
    fields: [
      { name: "title", label: "Başlık", type: "text" },
      { name: "image", label: "Görsel", type: "image", preset: "hero", full: true },
      { name: "description", label: "Açıklama", type: "textarea", full: true },
      { name: "order", label: "Sıra", type: "number" },
      { name: "active", label: "Aktif", type: "switch" },
    ],
  },
};
